const getItem = (key: string) => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === "undefined" || raw === "") return null;

    // Si es un objeto serializado (JSON), lo parseamos.
    // Si es un string plano (como un JWT), lo devolvemos tal cual.
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};

const setItem = (key: string, value: any) => {
  const stringify = typeof value === 'string' ? value : JSON.stringify(value);
  localStorage.setItem(key, stringify);
};

const removeItem = (key: string) => {
  localStorage.removeItem(key);
};

export { getItem, setItem, removeItem };
